import { Route, Routes } from "react-router-dom";
import SettingStandardsLibraryView from "../views/settings/SettingStandardsLibraryView";

const SettingStandardsLibraryRoutes = (props: any) => {
  return (
    <Routes>
      {/* Shared layout for list pages */}
      <Route path='*' element={<SettingStandardsLibraryView {...props} />} />
    </Routes>
  );
};

export default SettingStandardsLibraryRoutes;
